export const whenCallReturns = (callback) => {
  let left = document.visibilityState === "hidden";
  let finished = false;
  const complete = () => {
    if (finished) return;
    finished = true;
    document.removeEventListener("visibilitychange", visibility);
    callback();
  };
  const visibility = () => {
    if (document.visibilityState === "hidden") left = true;
    else if (left) complete();
  };
  document.addEventListener("visibilitychange", visibility);
  window.setTimeout(() => { if (!left && document.visibilityState === "visible") complete(); }, 1600);
};